import { TextField, TextFieldProps, useMediaQuery, useTheme } from '@mui/material';
import { Controller, Control } from 'react-hook-form';

interface Props extends Omit<TextFieldProps, 'name'> {
  name: string;
  helperText?: React.ReactNode;
  control: Control<any>;
  rules?: any;
}

export default function Input({ name, control, helperText = null, rules, ...textFieldProps }: Props) {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const size = textFieldProps.size || (isLargeScreen ? 'medium' : 'small');

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          autoComplete='off'
          {...textFieldProps}
          size={size}
          error={!!error}
          helperText={error ? error.message : helperText}
          InputLabelProps={{
            shrink: !!field.value || undefined,
            ...textFieldProps.InputLabelProps
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#ececec' // Default border color
              }
            },
            '& .MuiFormLabel-asterisk': {
              color: 'red'
            }
          }}
        />
      )}
    />
  );
}
